/**
 * レセプト内容一覧 — masseurs dropdown (depends on 提出年月).
 * Pass `null` to skip the query.
 */

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import useAppToast from '@/hooks/useAppToast';
import { useClinicContext } from '@/hooks/main/useClinicContext';
import { useTheme } from '@shared/providers/theme/ThemeContext';
import { DEFAULT_FETCH_ERROR_MESSAGE, getApiErrorMessage } from '@/utils/apiError';
import { getRezeptHistoriesMassagers } from '@/services/main/rezeptHistories';
import type { MassagerOption } from '@/pages/main/rezeptHistories/types';

export const useRezeptHistoriesMassagers = (yearmonth: string | null) => {
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();
  const toast = useAppToast();

  const { data, isLoading, isError, error } = useQuery<MassagerOption[], Error>({
    queryKey: ['rezept-histories', 'massagers', tenant, clinicNumber, serviceType, yearmonth],
    queryFn: () =>
      getRezeptHistoriesMassagers(tenant, clinicNumber, yearmonth as string, serviceType),
    enabled: !!tenant && !!clinicNumber && !!yearmonth,
    staleTime: 60_000,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data: data ?? [], isLoading };
};
